function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { forwardRef, useState } from 'react';
import { Checkmark } from "../../icons";
import { BottomSheetContentLayout } from "../BottomSheet";
import { useOverlayContext } from "../OverlayContext";
import { MobileSummaryCard } from "../TextField";
import { MobileTextFieldTID } from "../TextField/BaseTextField/BaseTextField.utils";
import { Typography } from "../Typography";
import styles from "./MobileSelect.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SelectOptionsBottomSheet(props) {
  const {
    children,
    isSelected,
    saveOnSelect,
    testId
  } = props;
  const {
    popBottomSheetPage
  } = useOverlayContext();
  const [tempValue, setTempValue] = useState(props.value);
  function handleSave(returnValue) {
    const valueToSave = returnValue != null ? returnValue : tempValue;
    if (valueToSave !== props.value && props.onChange) {
      props.onChange({
        target: {
          value: valueToSave
        }
      });
    }
    popBottomSheetPage();
  }
  const clonedChildren = React.Children.map(children, child => {
    if ( /*#__PURE__*/React.isValidElement(child)) {
      const childProps = child.props;
      const childTestId = childProps.testId;
      const selected = isSelected ? isSelected(childProps.value, tempValue) : childProps.value === tempValue;
      return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, childProps), {}, {
        selected,
        children: /*#__PURE__*/_jsxs("div", {
          className: styles.item,
          children: [childProps.children, selected && /*#__PURE__*/_jsx("div", {
            className: styles.noShrink,
            "data-testid": MobileTextFieldTID.SelectedItem(childTestId || testId),
            children: /*#__PURE__*/_jsx(Checkmark, {})
          })]
        }),
        onClick: () => saveOnSelect ? handleSave(childProps.value) : setTempValue(childProps.value)
      }));
    }
    return null;
  });
  return /*#__PURE__*/_jsx(BottomSheetContentLayout, {
    header: props.label ? {
      title: props.label,
      paddingBottom: 16
    } : undefined,
    footer: !saveOnSelect ? {
      primaryAction: {
        text: 'Save',
        onClick: () => handleSave()
      },
      paddingTop: 8
    } : undefined,
    children: clonedChildren
  });
}
export const MobileSelect = /*#__PURE__*/forwardRef(function MobileSelect(props, _ref) {
  const {
    testId,
    disabled
  } = props;
  const {
    pushBottomSheetPage
  } = useOverlayContext();
  return /*#__PURE__*/_jsx(MobileSummaryCard, {
    disabled: disabled,
    testId: testId,
    title: props.label,
    body: /*#__PURE__*/_jsx(Typography, {
      ellipsis: true,
      children: props.displayValue || props.value
    }),
    titleTestId: MobileTextFieldTID.Label(testId),
    bodyTestId: MobileTextFieldTID.Value(testId),
    editButtonTestId: MobileTextFieldTID.EditButton(testId),
    onEdit: () => pushBottomSheetPage({
      content: /*#__PURE__*/_jsx(SelectOptionsBottomSheet, _objectSpread({}, props))
    })
  });
});